'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _templateObject = _taggedTemplateLiteral(['background-image: url(', ');'], ['background-image: url(', ');']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactEmotion = require('react-emotion');
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _lodash = require('lodash');
var _BazaarVoiceModal = require('../bazaarvoice/BazaarVoiceModal');
var _BazaarVoiceModal2 = _interopRequireDefault(_BazaarVoiceModal);
var _ProductCard = require('../productCard/ProductCard');
var _ProductCard2 = _interopRequireDefault(_ProductCard);
var _bottleShadow = require('../../../images/7up/products/bottle-shadow.png');
var _bottleShadow2 = _interopRequireDefault(_bottleShadow);
var _arrowsProducts = require('../../../images/7up/products/arrows-products.jpg');
var _arrowsProducts2 = _interopRequireDefault(_arrowsProducts);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var CirclingCarousel = function (_React$Component) {
  _inherits(CirclingCarousel, _React$Component);
  function CirclingCarousel(props) {
    _classCallCheck(this, CirclingCarousel);
    var _this = _possibleConstructorReturn(this, (CirclingCarousel.__proto__ || Object.getPrototypeOf(CirclingCarousel)).call(this, props));
    _this.state = {
      activeProduct: null,
      activeIndex: 0
    };
    _this.bgClasses = {
      bottleShadow: (0, _reactEmotion.css)(_templateObject, _bottleShadow2.default),
      arrowsProducts: (0, _reactEmotion.css)(_templateObject, _arrowsProducts2.default)
    };
    _this.products = [];
    _this.handleProductClick = _this.handleProductClick.bind(_this);
    _this.handleNavClick = _this.handleNavClick.bind(_this);
    return _this;
  }
  _createClass(CirclingCarousel, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.activeProduct) {
        this.updateActiveProduct(this.props.activeProduct, this.getIndex(this.props.activeProduct));
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.activeProduct) this.goToProduct(this.state.activeIndex);
    }
  }, {
    key: 'getIndex',
    value: function getIndex(slug) {
      return (0, _lodash.findIndex)(this.props.products, function (p) {
        return p.slug === slug;
      });
    }
  }, {
    key: 'handleProductClick',
    value: function handleProductClick(e, product, index) {
      e.preventDefault();
      if (this.state.activeProduct !== product.slug) this.updateActiveProduct(product.slug, index);
    }
  }, {
    key: 'handleNavClick',
    value: function handleNavClick(index) {
      var productCount = this.props.products.length;
      var remainder = index % productCount;
      var cIndex = remainder < 0 ? remainder + productCount : remainder;
      this.updateActiveProduct(this.props.products[cIndex].slug, cIndex);
    }
  }, {
    key: 'updateActiveProduct',
    value: function updateActiveProduct(slug, index) {
      this.setState({
        activeProduct: slug
      });
      this.setState({
        activeIndex: index
      });
      this.goToProduct(index);
    }
  }, {
    key: 'goToProduct',
    value: function goToProduct(selectedIndex) {
      var _this2 = this;
      this.products.forEach(function (product, index) {
        var offset = index - selectedIndex;
        if (offset < 0) offset += _this2.products.length;
        product.className = 'circling-carousel__product'; // eslint-disable-line
        product.classList.add('circling-carousel__product--' + offset);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;
      return _react2.default.createElement('div', {
        className: 'circling-carousel ' + this.props.className
      }, _react2.default.createElement('div', {
        className: 'circling-carousel__inner'
      }, _react2.default.createElement('ul', {
        className: 'circling-carousel__products ' + (this.props.fourProducts ? 'circling-carousel__products--four' : '')
      }, this.props.products.map(function (product, index) {
        return _react2.default.createElement('li', {
          className: 'circling-carousel__product circling-carousel__product--' + index,
          key: 'circling-carousel-' + product.slug,
          ref: function ref(productRef) {
            _this3.products[index] = productRef;
          }
        }, _react2.default.createElement('a', {
          className: 'circling-carousel__product-link ' + _this3.bgClasses.bottleShadow,
          href: 'products/' + product.slug,
          onClick: function onClick(e) {
            return _this3.handleProductClick(e, product, index);
          }
        }, _react2.default.createElement('img', {
          className: 'circling-carousel__product-image',
          alt: product.image.alt,
          src: product.image.src
        })));
      })), _react2.default.createElement('div', {
        className: 'circling-carousel__nav'
      }, _react2.default.createElement('button', {
        className: 'circling-carousel__nav-btn circling-carousel__nav-btn--prev ' + this.bgClasses.arrowsProducts,
        onClick: function onClick() {
          return _this3.handleNavClick(_this3.state.activeIndex - 1);
        }
      }, 'prev'), _react2.default.createElement('button', {
        className: 'circling-carousel__nav-btn circling-carousel__nav-btn--next ' + this.bgClasses.arrowsProducts,
        onClick: function onClick() {
          return _this3.handleNavClick(_this3.state.activeIndex + 1);
        }
      }, 'next'))), this.state.activeProduct ? _react2.default.createElement(_ProductCard2.default, {
        active: true,
        bazaarVoiceEnabled: this.props.bazaarVoiceEnabled,
        className: 'circling-carousel__card',
        nutritionFacts: this.props.nutritionFacts,
        product: this.props.products.filter(function (product) {
          return _this3.state.activeProduct === product.slug;
        }).shift(),
        social: this.props.social,
        socialEnabled: this.props.socialEnabled
      }) : _react2.default.createElement('div', {
        className: 'circling-carousel__card circling-carousel__card--intro'
      }, this.props.intro), _react2.default.createElement(_BazaarVoiceModal2.default, null));
    }
  }]);
  return CirclingCarousel;
}(_react2.default.Component);
CirclingCarousel.defaultProps = {
  activeProduct: '',
  bazaarVoiceEnabled: true,
  className: '',
  fourProducts: false,
  intro: null,
  nutritionFacts: {},
  social: {},
  socialEnabled: true
};
CirclingCarousel.propTypes = {
  activeProduct: _propTypes2.default.string,
  bazaarVoiceEnabled: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  fourProducts: _propTypes2.default.bool,
  intro: _propTypes2.default.node,
  nutritionFacts: _propTypes2.default.shape({
    calorieSource: _propTypes2.default.string,
    dailyValue: _propTypes2.default.string,
    disclaimer: _propTypes2.default.string,
    factPunctuation: _propTypes2.default.string,
    ingredientsTitle: _propTypes2.default.string,
    perServing: _propTypes2.default.string,
    servingSize: _propTypes2.default.string,
    threeColumn: _propTypes2.default.bool
  }),
  products: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    brand_code: _propTypes2.default.string,
    description: _propTypes2.default.string,
    image: _propTypes2.default.shape({
      src: _propTypes2.default.string,
      alt: _propTypes2.default.string,
      type: _propTypes2.default.string
    }),
    ingredient: _propTypes2.default.array,
    name: _propTypes2.default.string,
    nutrition: _propTypes2.default.shape({}),
    product_info: _propTypes2.default.shape({
      serving_size: _propTypes2.default.string,
      serving_units_code: _propTypes2.default.string
    }),
    slug: _propTypes2.default.string,
    social: _propTypes2.default.shape({
      email: _propTypes2.default.shape({
        url: _propTypes2.default.string,
        subject: _propTypes2.default.string,
        message: _propTypes2.default.string
      }),
      facebook: _propTypes2.default.shape({
        url: _propTypes2.default.string,
        message: _propTypes2.default.string,
        subject: _propTypes2.default.string,
        image: _propTypes2.default.string
      }),
      pinterest: _propTypes2.default.shape({
        url: _propTypes2.default.string,
        message: _propTypes2.default.string,
        image: _propTypes2.default.string
      }),
      twitter: _propTypes2.default.shape({
        url: _propTypes2.default.string,
        message: _propTypes2.default.string
      })
    })
  })).isRequired,
  social: _propTypes2.default.shape({
    emailSubject: _propTypes2.default.string,
    emailMessage: _propTypes2.default.string,
    emailUrl: _propTypes2.default.string,
    facebookAppId: _propTypes2.default.string,
    facebookIcon: _propTypes2.default.oneOf(['default', 'square']),
    facebookImage: _propTypes2.default.string,
    facebookMessage: _propTypes2.default.string,
    facebookSubject: _propTypes2.default.string,
    facebookUrl: _propTypes2.default.string,
    pinterestIcon: _propTypes2.default.oneOf(['default', 'p', 'square']),
    pinterestImage: _propTypes2.default.string,
    pinterestMessage: _propTypes2.default.string,
    pinterestUrl: _propTypes2.default.string,
    twitterIcon: _propTypes2.default.oneOf(['default', 'square']),
    twitterMessage: _propTypes2.default.string,
    twitterUrl: _propTypes2.default.string,
    services: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['email', 'facebook', 'pinterest', 'print', 'twitter']))
  }),
  socialEnabled: _propTypes2.default.bool
};
exports.default = CirclingCarousel;